import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {AuthService} from './shared/services/auth.service'
import {AuthGuardService} from './shared/services/auth-guard.service';
import {HTTP_INTERCEPTOR_PROVIDERS} from './shared/services/http-interceptor.providers';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SystemNotificationsComponent} from "./shared/components/system-notifications/system-notifications.component";
import {CommonModule, DatePipe, NgFor} from "@angular/common";
import {TopNavbarComponent} from "./shared/components/navbars/top-navbar/top-navbar.component";
import {LoginComponent} from "./login/login.component";
import {LoadingSpinnerComponent} from "./shared/components/loading-spinner/loading-spinner.component";
import {MainComponent} from './main/main.component';
import {SelectStationsOnMapComponent} from './select-stations-on-map/select-stations-on-map.component';
import {GraphPageComponent} from './graph/graph-page/graph-page.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatListModule} from "@angular/material/list";
import {MatTreeModule} from "@angular/material/tree";
import {MatIconModule} from "@angular/material/icon";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MAT_DATE_LOCALE, MatNativeDateModule} from "@angular/material/core";
import {MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {SelectGraphForm} from './graph/graph-form/graph-form.component';
import {GraphSelectedVariablesListComponent} from './graph/graph-selected-variables-list/graph-selected-variables-list.component';
import {GraphComponent} from './graph/graph.component';
import {EchartsxModule} from 'echarts-for-angular';
import {MatChipsModule} from "@angular/material/chips";
import {MatRadioModule} from "@angular/material/radio";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {GraphTypeComponent} from './graph/graph-type/graph-type.component';
import {CookieService} from "ngx-cookie-service";
import {GraphDataTransformersComponent} from './graph/graph-data-transformers/graph-data-transformers.component';
import {MatTableModule} from "@angular/material/table";
import { HeatmapComponent } from './heatmap/heatmap.component';
import {MatSliderModule} from "@angular/material/slider";
import {MatCardModule} from "@angular/material/card";
import { ProductCatalogComponent } from './product-catalog/product-catalog.component';
import {MatLegacyChipsModule} from "@angular/material/legacy-chips";
import { ProductPageComponent } from './product-page/product-page.component';
import { MinPipe } from './shared/pipes/min.pipe';
import { MaxPipe } from './shared/pipes/max.pipe';
import { VariableDisplayNamePipe } from './shared/pipes/variable-display-name.pipe';
import {MatExpansionModule} from "@angular/material/expansion";
import { DatasetGraphComponent } from './dataset-graph/dataset-graph.component';
import {MatTabsModule} from "@angular/material/tabs";
import {MatDialogModule} from "@angular/material/dialog";
import { GraphVariableSelectorComponent } from './graph/graph-variable-selector/graph-variable-selector.component';
import { DatasetVariableSelectorComponent } from './graph/dataset-variable-selector/dataset-variable-selector.component';
import { ProductPageChartsComponent } from './product-page/product-page-charts/product-page-charts.component';
import { ProductPageDataComponent } from './product-page/product-page-data/product-page-data.component';
import { DownloadCitationDialogComponent } from './shared/components/download-citation-dialog/download-citation-dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    SystemNotificationsComponent,
    TopNavbarComponent,
    LoginComponent,
    LoadingSpinnerComponent,
    MainComponent,
    SelectStationsOnMapComponent,
    GraphPageComponent,
    SelectGraphForm,
    GraphSelectedVariablesListComponent,
    GraphComponent,
    GraphTypeComponent,
    GraphDataTransformersComponent,
    HeatmapComponent,
    ProductCatalogComponent,
    ProductPageComponent,
    MinPipe,
    MaxPipe,
    VariableDisplayNamePipe,
    DatasetGraphComponent,
    GraphVariableSelectorComponent,
    DatasetVariableSelectorComponent,
    ProductPageChartsComponent,
    ProductPageDataComponent,
    DownloadCitationDialogComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    FontAwesomeModule,
    NgbModule,
    GoogleMapsModule,
    BrowserAnimationsModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    MatInputModule,
    MatMenuModule,
    MatButtonModule,
    MatCheckboxModule,
    MatListModule,
    MatTreeModule,
    MatIconModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    EchartsxModule,
    MatChipsModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSliderModule,
    MatCardModule,
    MatLegacyChipsModule,
    MatExpansionModule,
    MatTabsModule,
    MatDialogModule
  ],
  providers: [
    DatePipe,
    CookieService,
    AuthService,
    AuthGuardService,
    // Order-sensitive; see the comment on HTTP_INTERCEPTOR_PROVIDERS (#34).
    ...HTTP_INTERCEPTOR_PROVIDERS,
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {
        useUtc: true
      }
    },
    {
      provide: MAT_DATE_LOCALE, useValue: 'en-GB'
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
